import AbilitySelector from './src/main';

/* istanbul ignore next */
AbilitySelector.install = function(Vue) {
  Vue.component(AbilitySelector.name, AbilitySelector);
};

export default AbilitySelector;
